///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.set_3pl = abcsetup.dashboard.set_3pl || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.set_3pl = {
    init: function() {
        $(document).on('click', '.btn-3pl', function () {
            abcsetup.dashboard.set_3pl.select3PLRole($(this).data('role'), $(this).data('id'), $(this).data('route'));
            return false;
        });

        $(document).on('click', '#3pl_create', function () {
            abcsetup.dashboard.set_3pl.select3PLRole($('#3pl_role_select').val(), null, 'create');
            return false;
        });
    },

    /**
     *
     * @param {*} id
     */
    select3PLRole(role, id = null, route) {
        abcsetup.blockUI(true, true);
        $.get('/api/set_cases/3pl/' + role + '/' + id + '/' + route, function(data) {
            abcsetup.blockUI(true, true);
            window.location.href = data.intended_url;
        });
    },
}